/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BusinessUnionTypeEnum } from '../../../app.admin/modules/model/business-union-type.enum';

export interface Open360BusinessLogicRetailersAccountBERetailerProfile {
    ID?: number;
    FirstName: string;
    LastName: string;
    CompanyName: string;
    phone?: string;
    PhoneNumber: IPhoneNumberFullInfo;
    WhatsAppNumber?: IPhoneNumberFullInfo;
    Email: string;
    ViewedPrivacyNotification?: boolean;
    CountryID: number;
    CountryName?: string;
    CurrencyID?: number;
    CurrencySign?: string;
    LanguageID?: number;
    LogoID?: number;
    Story?: string;
    /**
     * 0 = Unverified, 1 = Verified, 2 = Suspended, 3 = Closed, 4 = Template
     */
    RetailerStatus?: Open360BusinessLogicRetailersAccountBERetailerProfile.RetailerStatusEnum;
    /**
     * 1 = Retailer, 2 = StoreManager
     */
    Permission?: Open360BusinessLogicRetailersAccountBERetailerProfile.PermissionEnum;
    ShowGetStarted?: boolean;
    LoyaltyProgramEnabled?: boolean;
    RetailerType?: RetailerType;
    BusinessUnionType?: BusinessUnionTypeEnum;
}

export type AccountTypeEnum = 0 | 1 | 2;
export type RetailerType = 0 | 1;

//  0 = Standard, 1 = Pro, 2 = Enterprise

export namespace Open360BusinessLogicRetailersAccountBERetailerProfile {
    export type RetailerStatusEnum = 0 | 1 | 2 | 3 | 4;
    export const RetailerStatusEnum = {
        NUMBER_0: 0 as RetailerStatusEnum,
        NUMBER_1: 1 as RetailerStatusEnum,
        NUMBER_2: 2 as RetailerStatusEnum,
        NUMBER_3: 3 as RetailerStatusEnum,
        NUMBER_4: 4 as RetailerStatusEnum
    }

    export type PermissionEnum = 1 | 2;
    export const PermissionEnum = {
        NUMBER_1: 1 as PermissionEnum,
        NUMBER_2: 2 as PermissionEnum
    }
}

export interface IPhoneNumberFullInfo {
    CountryPhoneCodeID: number;
    PhoneNumberWithoutCode?: string;
    PhoneNumber: string;
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicRetailersAccountBERetailerProfile.ts